type EventMap = {
  'my-apps:open': { triggerRect?: DOMRect };
  'my-apps:close': void;
  'spotlight:open': void;
  'spotlight:close': void;
  'app:navigate': { appId: string; url: string };
};

type Handler<T> = (payload: T) => void;

class EventBus {
  private listeners = new Map<string, Set<Handler<unknown>>>();

  on<K extends keyof EventMap>(event: K, handler: Handler<EventMap[K]>): () => void {
    const key = event as string;
    if (!this.listeners.has(key)) {
      this.listeners.set(key, new Set());
    }
    this.listeners.get(key)!.add(handler as Handler<unknown>);
    return () => this.off(event, handler);
  }

  off<K extends keyof EventMap>(event: K, handler: Handler<EventMap[K]>): void {
    this.listeners.get(event as string)?.delete(handler as Handler<unknown>);
  }

  emit<K extends keyof EventMap>(event: K, payload?: EventMap[K]): void {
    for (const handler of this.listeners.get(event as string) ?? []) {
      handler(payload as EventMap[K]);
    }
  }
}

// Singleton: meski di-bundle ke multiple packages, instance bus tetap satu
declare global {
  interface Window {
    __mjl?: {
      bus?: EventBus;
      config?: unknown;
      cssUrl?: string;
      uiKitCssText?: string;
      uiKitSheet?: CSSStyleSheet;
    };
  }
}

if (typeof window !== 'undefined') {
  window.__mjl ??= {};
  window.__mjl.bus ??= new EventBus();
}

export const bus = (typeof window !== 'undefined' ? window.__mjl!.bus! : new EventBus());
